import React, { Dispatch, SetStateAction } from 'react';
import './table.module.scss';
import { Table } from 'antd';
import 'antd/lib/table/style/css';
import { variables } from '../../utils/variables';

interface ITable {
  columns: object[];
  data: object[];
  updateData?: Dispatch<
    SetStateAction<
      { lastName: string; firstName: string; email: string; date: string }[]
    >
  >;
  components?: any;
  rowClassName?: any;
  onChange?: any;
  total?: any;
  pageSize?: any;
}
const CTable = (props: ITable) => {
  function onChange(pagination: any, filters: any, sorter: any, extra: any) {
    console.log('params', pagination, filters, sorter, extra);
    props.onChange(pagination, filters, sorter, extra);
  }
  return (
    <Table
      showSorterTooltip={false}
      pagination={{
        pageSize: props.pageSize ?? variables.paginationRatio,
        total: props.total ?? props.data.length,
        position: ['bottomCenter'],
        defaultCurrent: 1
      }}
      locale={{
        emptyText: 'Momentan nu exista date.'
      }}
      dataSource={props.data}
      onChange={onChange}
      {...props}
    />
  );
};

export default CTable;
